























































import AddFilter from "../components/filters/AddFilter.vue";
import ChangeHeaders from "../components/vehicles/ChangeHeaders.vue";
import { Component, Watch, Vue } from "vue-property-decorator";
import MultilineChip from "../components/global/MultilineChip.vue";
import { namespace } from "vuex-class";
import Vehicle from "../models/vehicle";
import VehiclesTable from "../components/vehicles/VehiclesTable.vue";
import { Filter } from "../models/filter";
import {
  FilterProperties,
  SearchVehiclesQueryContext,
} from "../api/dto/searchVehiclesQueryContext";

const filter = namespace("filter");
const vehicle = namespace("vehicle");

@Component({
  components: {
    AddFilter,
    ChangeHeaders,
    MultilineChip,
    VehiclesTable,
  },
})
export default class Vehicles extends Vue {
  showTableSettings = false;

  @filter.Getter("getAllHeaders")
  allHeaders!: Record<string, any>[];

  @filter.Getter("getFilterProperties")
  filterProperties!: FilterProperties[];

  @filter.Getter("getFilters")
  filters!: Filter[];

  @filter.Getter("getActiveHeaders")
  headers!: Record<string, any>[];

  @vehicle.Getter("isLoading")
  isLoading!: boolean;

  get hasFilters(): boolean {
    return this.filters.length > 0;
  }

  @filter.Getter("getLimit")
  limit!: number;

  @filter.Getter("getOffset")
  offset!: number;

  get options(): any {
    return {
      sortDesc: this.sortDesc,
      page: this.page,
      itemsPerPage: this.limit,
      sortBy: this.sortBy,
    };
  }

  @filter.Getter("getPage")
  page!: number;

  @filter.Getter("getSortDesc")
  sortDesc!: boolean[];

  @filter.Getter("getSortBy")
  sortBy!: string[];

  @filter.Getter("getSortDir")
  sortDir!: string[];

  @vehicle.Getter("getTotal")
  totalVehicles!: number;

  @vehicle.Getter("getVehicles")
  vehicles!: Vehicle[];

  @Watch("filters")
  onFiltersChanged(_val: Filter[], _oldVal: Filter[]) {
    this.fetchVehicles();
  }

  mounted() {
    this.fetchVehicles();
  }

  @filter.Action("addFilter")
  addFilter!: (filter: Filter) => Promise<void>;

  @filter.Action("clearFilters")
  clearFilters!: () => Promise<void>;

  @filter.Action("disableHeader")
  disableHeader!: (key: string) => Promise<void>;

  @filter.Action("enableHeader")
  enableHeader!: (key: string) => Promise<void>;

  @vehicle.Action("fetchAll")
  fetchAllVehicles!: (options: any) => Promise<any>;

  @filter.Action("removeFilter")
  removeFilter!: (index: number) => Promise<void>;

  @filter.Action("setPagination")
  setPagination!: (options: any) => Promise<void>;

  fetchVehicles(): void {
    let queryContext = new SearchVehiclesQueryContext(
      this.filterProperties,
      this.limit,
      this.offset,
      this.sortBy,
      this.sortDir
    );

    this.fetchAllVehicles(queryContext);
  }

  updateOptions(options: any) {
    this.setPagination(options).then(() => {
      this.fetchVehicles();
    });
  }
}
